import { render, staticRenderFns } from "./Workgroup.vue?vue&type=template&id=49b2c155&"
import script from "./Workgroup.vue?vue&type=script&lang=js&"
export * from "./Workgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports